'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest(origin, algo, encoding, encapsulate, files) {
  this.wD = null;
  this.BZ = null;
  this.C1 = null;
  this.C0 = false;
  this.C2 = null;
  this.wD = origin;
  this.BZ = algo;
  this.C1 = encoding;
  this.C0 = encapsulate;
  this.C2 = files;
}
export { $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest as $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest };
$p = $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest as $h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest };
$h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("LocalPjeOfficeSignFileRequest"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.wD));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.BZ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.C1));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.C0 ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.C2));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 5);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest)) {
    if (((((this.C0 === x$0.C0) && (this.wD === x$0.wD)) && (this.BZ === x$0.BZ)) && (this.C1 === x$0.C1))) {
      var x = this.C2;
      var x$2 = x$0.C2;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "LocalPjeOfficeSignFileRequest";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.wD;
      break;
    }
    case 1: {
      return this.BZ;
      break;
    }
    case 2: {
      return this.C1;
      break;
    }
    case 3: {
      return this.C0;
      break;
    }
    case 4: {
      return this.C2;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.pn = (function() {
  return this.wD;
});
function $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hE)));
}
export { $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileRequest as $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileRequest };
var $d_Lpresto_AgentView$LocalPjeOfficeSignFileRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest, "presto.AgentView$LocalPjeOfficeSignFileRequest", ({
  hE: 1,
  b5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeSignFileRequest as $d_Lpresto_AgentView$LocalPjeOfficeSignFileRequest };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Sign-File-Request.js.map
